import React, { useEffect } from 'react'
import { message } from 'antd'
import { useMutation, DocumentNode } from '@apollo/client'
import { Route, Navigate, useLocation, Routes } from 'react-router-dom'
import Loading from '../Loading'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'

interface Props {
  redirectUrl: string
  connectVariables: {
    merchantId?: string
    storeId?: string
  }
  connectMutation: DocumentNode
}
const StripeConnect = ({
  redirectUrl,
  connectVariables,
  connectMutation
}: Props) => {
  const { refetchStripeConnectData } = useMerchant()
  const queryParams = new URLSearchParams(useLocation().search)
  const authCode = queryParams.get('code')

  const [connectAndUpdateStripeSettings, { loading: connectLoading }] =
    useMutation(connectMutation, {
      fetchPolicy: 'no-cache'
    })

  useEffect(() => {
    if (authCode) {
      connectAndUpdateStripeSettings({
        variables: {
          authCode,
          ...connectVariables
        }
      })
        .then(() => {
          refetchStripeConnectData()
        })
        .catch((error) => {
          if (error.message) {
            message.error(
              `Failed to connect stripe account. ${error.message}`,
              1
            )
          } else {
            message.error(
              'Failed to connect stripe account. Please try again',
              1
            )
          }
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authCode])

  return connectLoading ? (
    <Loading />
  ) : (
    <Navigate to={redirectUrl} state={{ from: location }} />
  )
}

interface WrapperProps {
  path: string
  redirectUrl: string
  connectMutation: DocumentNode
  connectVariables: {
    merchantId?: string
    storeId?: string
  }
}

export const StripeConnectRoute = ({
  path,
  redirectUrl,
  connectVariables,
  connectMutation
}: WrapperProps) => {
  return (
    <Routes>
      <Route
        path={path}
        element={
          <StripeConnect
            redirectUrl={redirectUrl}
            connectVariables={connectVariables}
            connectMutation={connectMutation}
          />
        }
      />
    </Routes>
  )
}
